/**
 * Sorting helper
 */
export abstract class SortHelper {
  /**
   * Gets a sorter for an array
   * @param fieldName The field name
   * @returns The sorter function
   */
  public static sortArrayBy(fieldName: string) {
    return (a: any, b: any) => {
      if (a[fieldName] < b[fieldName]) {
        return -1;
      }
      if (a[fieldName] > b[fieldName]) {
        return 1;
      }
      return 0;
    }
  }
}
